import React from 'react';

/**
 * Skeleton loader component for student cards
 * Matches the layout structure of student cards with shimmer animation
 */
function SkeletonLoader() {
  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden animate-pulse">
      {/* Card Header with Avatar and Status */}
      <div className="relative p-6 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="flex items-start justify-between">
          <div className="flex items-center space-x-4 flex-1">
            <div className="relative">
              {/* Avatar Skeleton */}
              <div className="w-16 h-16 rounded-full bg-gray-300 border-4 border-white"></div>
              {/* Status Badge Skeleton */}
              <div className="absolute bottom-0 right-0 h-5 w-5 rounded-full bg-gray-300 border-2 border-white"></div>
            </div>
            <div className="flex-1 min-w-0">
              {/* Name Skeleton */}
              <div className="h-5 bg-gray-300 rounded w-32 mb-2"></div>
              {/* Email Skeleton */}
              <div className="h-4 bg-gray-200 rounded w-40 mb-1"></div>
              {/* Phone Skeleton */}
              <div className="h-3 bg-gray-200 rounded w-24"></div>
            </div>
          </div>
          {/* Actions Menu Skeleton */}
          <div className="w-8 h-8 rounded-full bg-gray-200"></div>
        </div>
      </div>

      {/* Card Body */}
      <div className="p-6 space-y-4">
        {/* Program Info Skeleton */}
        <div className="border-b border-gray-100 pb-4">
          <div className="flex items-center justify-between mb-2">
            <div className="h-3 bg-gray-200 rounded w-16"></div>
            <div className="h-3 bg-gray-200 rounded w-20"></div>
          </div>
          <div className="h-4 bg-gray-300 rounded w-40 mb-2"></div>
        </div>

        {/* Payment Info Skeleton */}
        <div className="border-b border-gray-100 pb-4">
          <div className="flex items-center justify-between mb-3">
            <div className="h-3 bg-gray-200 rounded w-20"></div>
            <div className="h-5 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <div className="h-3 bg-gray-200 rounded w-12"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>
            <div className="flex justify-between">
              <div className="h-3 bg-gray-200 rounded w-10"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>
            <div className="flex justify-between">
              <div className="h-3 bg-gray-200 rounded w-16"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>
          </div>
        </div>

        {/* Progress Bar Skeleton */}
        <div className="space-y-2">
          <div className="flex justify-between">
            <div className="h-3 bg-gray-200 rounded w-20"></div>
            <div className="h-3 bg-gray-200 rounded w-12"></div>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-gray-300 h-2 rounded-full w-3/4"></div>
          </div>
        </div>

        {/* Join Date Skeleton */}
        <div className="flex items-center justify-between pt-2">
          <div className="h-3 bg-gray-200 rounded w-24"></div>
          <div className="h-3 bg-gray-200 rounded w-20"></div>
        </div>
      </div>
    </div>
  );
}

export default SkeletonLoader;

